module.exports = __webpack_public_path__ + "img/titlevi.a8c1b5b5.png";